var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47656 50H27.3516C29.9395 50 32.0391 47.9004 32.0391 45.3125V4.6875C32.0391 2.09961 29.9395 0 27.3516 0H5.47656C2.88867 0 0.789062 2.09961 0.789062 4.6875V45.3125C0.789062 47.9004 2.88867 50 5.47656 50ZM2.35156 4.6875C2.35156 2.96484 3.75391 1.5625 5.47656 1.5625H27.3516C29.0742 1.5625 30.4766 2.96484 30.4766 4.6875V45.3125C30.4766 47.0352 29.0742 48.4375 27.3516 48.4375H5.47656C3.75391 48.4375 2.35156 47.0352 2.35156 45.3125V4.6875ZM11.7266 44.5312H21.1016C21.5318 44.5312 21.8828 44.1818 21.8828 43.75C21.8828 43.3182 21.5318 42.9688 21.1016 42.9688H11.7266C11.2963 42.9688 10.9453 43.3182 10.9453 43.75C10.9453 44.1818 11.2969 44.5312 11.7266 44.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.c3e5d6d7e26a9b0a8e648022fcdee1e0.svg";
export { ForwardRef as ReactComponent };